import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const CircleCloseFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M12 20.74C7.18 20.74 3.18 16.76 3.18 11.96C3.18 7.16 7.18 3.18 12 3.18C16.82 3.18 20.82 7.16 20.82 11.96C20.82 16.76 16.82 20.74 12 20.74ZM8.26 14.6L9.36 15.7L12 13.06L14.64 15.7L15.74 14.6L13.1 11.96L15.74 9.32L14.64 8.22L12 10.86L9.36 8.22L8.26 9.32L10.9 11.96L8.26 14.6Z" />
    </SvgIcon>
  );
});
